"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRelatedSearchSyncStatus = exports.getRelatedSearches = exports.getOrCreateRelatedSearchIndex = void 0;
const client_1 = require("../../_generated/client");
const helpers_1 = require("../helpers");
/**
 * Creates or gets related serach index model
 * @param access - Dashboard access function {@link DashboardAccess}
 * @param internalGroupId  - Dashboard access function {@link DashboardAccess}
 * @param options
 */
async function getOrCreateRelatedSearchIndex(access, internalGroupId, relatedSearchIndexName) {
    const indexes = await new client_1.RelatedSearchesApi(await access()).getRelatedSearchesIndexes(internalGroupId);
    const model = indexes.data.find((c) => c.resource.name === relatedSearchIndexName);
    if (model)
        return model;
    const createRelatedSearchesIndex = async (indexName) => new client_1.RelatedSearchesApi(await access()).createRelatedSearchesIndex(internalGroupId, {
        name: indexName
    }).then((q) => q.data);
    return createRelatedSearchesIndex(relatedSearchIndexName);
}
exports.getOrCreateRelatedSearchIndex = getOrCreateRelatedSearchIndex;
/**
 * Function will return related searches from
 * @param access - Dashboard access function {@link DashboardAccess}
 */
async function getRelatedSearches(access, relatedSearchesConfig) {
    const { internalGroupName, relatedSearchesGroupName } = relatedSearchesConfig;
    const group = await helpers_1.getOrCreateGroupByName(access, internalGroupName);
    const refimentGroupModel = await getOrCreateRelatedSearchIndex(access, group.id, relatedSearchesGroupName);
    const getRelatedSearchesIndexItems = async () => new client_1.RelatedSearchesApi(await access()).getRelatedSearchesIndexItems(group.id, refimentGroupModel.id);
    const items = await getRelatedSearchesIndexItems();
    return items.data;
}
exports.getRelatedSearches = getRelatedSearches;
/**
 * Update sync status in dashboard ui
 * @param access - Dashboard access function {@link DashboardAccess}
 */
async function withRelatedSearchSyncStatus(access, relatedSearchesConfig, fn) {
    const { internalGroupName, relatedSearchesGroupName } = relatedSearchesConfig;
    const group = await helpers_1.getOrCreateGroupByName(access, internalGroupName);
    const refimentGroupModel = await getOrCreateRelatedSearchIndex(access, group.id, relatedSearchesGroupName);
    await new client_1.RelatedSearchesApi(await access()).updateRelatedSearchesIndexLastSyncStart(group.id, refimentGroupModel.id);
    return fn().finally(async () => {
        await new client_1.RelatedSearchesApi(await access()).updateRelatedSearchesIndexLastSyncEnd(group.id, refimentGroupModel.id);
    });
}
exports.withRelatedSearchSyncStatus = withRelatedSearchSyncStatus;
